module.exports = __webpack_public_path__ + "img/040.3be868a2.jpg";